/*
 * @Author: 赵泽文
 * @Date: 2022-06-01 10:14:29
 * @LastEditors: 赵泽文
 * @LastEditTime: 2022-06-01 11:03:04
 * @Description: 门店配送价model
 */

import type {
  ILocationChainPriceModel,
  ILocationChainPriceStore,
} from '@monorepo/types/orders/locationChainPrice/locationChainPrice.types';

const initState: ILocationChainPriceStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    pageSize: 50,
    page: 1,
    sort_order: 'CREATED_DESC',
  },
};

const locationChainPrice: ILocationChainPriceModel = {
  namespace: 'locationChainPriceStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default locationChainPrice;
